<svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8369 27.7983C-10.8293 13.0595 7.83739 -2.94055 15.8369 7.17686C23.8374 -2.94055 42.504 13.0595 15.8369 27.7983Z" stroke="currentColor" stroke-width="1.5"/>
</svg>
